import { useQuery } from '@tanstack/react-query';

import {
  getInactiveIntegrationTokens,
  getActiveIntegrationTokens,
} from '@/features/integrations/api/get-integration-tokens';
import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';

export const ACTIVE_INTEGRATIONS_QUERY_KEY = 'activeIntegrations';
export const INACTIVE_INTEGRATIONS_QUERY_KEY = 'inactiveIntegrations';

export function useIntegrationTokens(onlyInactiveTokens: boolean = false) {
  const currentOrgId = useCurrentOrgId();

  return useQuery({
    queryKey: [
      onlyInactiveTokens
        ? INACTIVE_INTEGRATIONS_QUERY_KEY
        : ACTIVE_INTEGRATIONS_QUERY_KEY,
      currentOrgId,
    ],
    queryFn: () =>
      onlyInactiveTokens
        ? getInactiveIntegrationTokens(currentOrgId ?? 0)
        : getActiveIntegrationTokens(currentOrgId ?? 0),
    enabled: !!currentOrgId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
